/* istanbul ignore file */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Center } from '@chakra-ui/react';
import { FieldType, FormTranslationKeys, Property } from '@common/entities';

import StaticText from 'components/fields/StaticText';

import RouteRadioButton from './RouteRadioButton';

export interface Version {
  status: string;
}

interface Props {
  field: any;
  setTargetId: (id: string) => void;
  setTargetType: (type: string) => void;
  setTargetName: (name: string) => void;
  setTargetProperties?: (properties: Property[]) => void;
}
export function RenderRouteField(props: Props) {
  const { field, setTargetId, setTargetType, setTargetName, setTargetProperties } = props;
  const { t } = useTranslation('viewer');
  const translatedLabel = field?.id
    ? t(FormTranslationKeys.field.label(field.id), field.label)
    : field.label;
  const translatedOptions = (field.options || []).map((option: any, index: number) => ({
    ...option,
    label: field?.id
      ? t(FormTranslationKeys.field.optionLabel(field.id, option.id ?? index), option.label)
      : option.label,
  }));

  return (
    <Center>
      {field.type === FieldType.StaticText ? (
        <StaticText id={field.id} label={translatedLabel} />
      ) : (
        <RouteRadioButton
          id={field.id}
          label={translatedLabel}
          options={translatedOptions}
          name={field.name}
          setTargetId={setTargetId}
          setTargetType={setTargetType}
          setTargetName={setTargetName}
          setTargetProperties={setTargetProperties}
        />
      )}
    </Center>
  );
}
